var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    {
      staticClass: "px-0",
      staticStyle: { "max-width": "none" },
      attrs: { "fill-height": "" }
    },
    [
      _c(
        "v-container",
        { staticClass: "mx-0", staticStyle: { "max-width": "none" } },
        [
          _vm.openAccessPermissionDetail
            ? _c("PDTDetail", {
                on: {
                  closeAccessPermissionDetail: _vm.closeAccessPermissionDetail
                }
              })
            : _vm._e(),
          _c(
            "v-row",
            { staticClass: "mx-5 px-0" },
            [
              _c(
                "v-col",
                { staticClass: "pa-0", attrs: { cols: "12" } },
                [
                  _c(
                    "v-row",
                    { staticClass: "mx-auto px-1" },
                    [
                      _c(
                        "v-col",
                        { staticClass: "pa-0 px-2", attrs: { cols: "12" } },
                        [
                          _c("v-text-field", {
                            staticClass: "pt-0 pb-1 mx-auto d-flex align-end",
                            attrs: { "single-line": "", "hide-details": "" },
                            scopedSlots: _vm._u([
                              {
                                key: "label",
                                fn: function() {
                                  return [
                                    _c(
                                      "p",
                                      {
                                        staticClass: "font-weight-light body-2"
                                      },
                                      [_vm._v("Buscar")]
                                    )
                                  ]
                                },
                                proxy: true
                              },
                              {
                                key: "append-outer",
                                fn: function() {
                                  return [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          fab: "",
                                          "x-small": "",
                                          outlined: "",
                                          icon: ""
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.applyKeywordFilter()
                                          }
                                        }
                                      },
                                      [
                                        _c("v-icon", { attrs: { small: "" } }, [
                                          _vm._v(" mdi-magnify ")
                                        ])
                                      ],
                                      1
                                    )
                                  ]
                                },
                                proxy: true
                              }
                            ]),
                            model: {
                              value: _vm.keyword,
                              callback: function($$v) {
                                _vm.keyword = $$v
                              },
                              expression: "keyword"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("v-divider"),
                  _c(
                    "v-row",
                    { staticClass: "py-1 mx-auto" },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "py-0 d-flex align-center",
                          attrs: { cols: "6" }
                        },
                        [
                          _c(
                            "v-tooltip",
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u([
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    return [
                                      _c(
                                        "v-btn",
                                        { attrs: { icon: "" } },
                                        [
                                          _c(
                                            "v-icon",
                                            _vm._g(
                                              {
                                                staticClass: "px-2",
                                                attrs: {
                                                  color:
                                                    !_vm.dataCenterId &&
                                                    !_vm.statusId &&
                                                    !_vm.emergencyAccess
                                                      ? "#603E99"
                                                      : "",
                                                  small: ""
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.disableAllFilters()
                                                  }
                                                }
                                              },
                                              on
                                            ),
                                            [
                                              _vm._v(
                                                " mdi-ticket-confirmation-outline "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  }
                                }
                              ])
                            },
                            [_c("span", [_vm._v("Todos")])]
                          ),
                          _c(
                            "v-tooltip",
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u([
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    return [
                                      _c(
                                        "v-chip",
                                        _vm._g(
                                          {
                                            staticClass: "mx-1",
                                            attrs: {
                                              color: _vm.emergencyAccess
                                                ? "red"
                                                : "",
                                              label: "",
                                              "x-small": "",
                                              outlined: ""
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.applyEmergencyAccessFilter()
                                              }
                                            }
                                          },
                                          on
                                        ),
                                        [_vm._v(" EMERGENCIA ")]
                                      )
                                    ]
                                  }
                                }
                              ])
                            },
                            [_c("span", [_vm._v("Cambios de Emergencia")])]
                          ),
                          _vm._l(_vm.dataCenters, function(dataCenter) {
                            return _c(
                              "v-tooltip",
                              {
                                key: dataCenter.id,
                                attrs: { bottom: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function(ref) {
                                        var on = ref.on
                                        return [
                                          _c(
                                            "v-chip",
                                            _vm._g(
                                              {
                                                staticClass: "mx-1",
                                                attrs: {
                                                  color:
                                                    dataCenter.id ===
                                                    _vm.dataCenterId
                                                      ? _vm.dataCenterColors[
                                                          dataCenter.id - 1
                                                        ]
                                                      : "",
                                                  label: "",
                                                  "x-small": "",
                                                  outlined: ""
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.applyDataCenterFilter(
                                                      dataCenter.id
                                                    )
                                                  }
                                                }
                                              },
                                              on
                                            ),
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(dataCenter.alias) +
                                                  " "
                                              )
                                            ]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              },
                              [_c("span", [_vm._v(_vm._s(dataCenter.name))])]
                            )
                          })
                        ],
                        2
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass:
                            "py-0 mx-auto d-flex align-center justify-end overline",
                          attrs: { cols: "6" }
                        },
                        [
                          _c("div", { staticClass: "px-2" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.accessPermissionsTotalPagesDisplayed !== 0
                                    ? _vm.currentPageDisplayed + " -"
                                    : ""
                                ) +
                                " " +
                                _vm._s(
                                  _vm.accessPermissionElementsPerPageDisplayed !==
                                    0 &&
                                    _vm.accessPermissionsTotalPagesDisplayed !==
                                      0
                                    ? _vm.accessPermissionElementsPerPageDisplayed
                                    : ""
                                ) +
                                " " +
                                _vm._s(
                                  _vm.accessPermissionsTotalPagesDisplayed !== 0
                                    ? "de " +
                                        _vm.accessPermissionsTotalPagesDisplayed
                                    : ""
                                ) +
                                " "
                            )
                          ]),
                          _c(
                            "v-tooltip",
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u([
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    return [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            icon: "",
                                            disabled:
                                              _vm.currentPage === 1 ||
                                              _vm.accessPermissionElementsPerPageDisplayed ===
                                                0
                                          }
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            _vm._g(
                                              {
                                                staticClass: "left-arrow",
                                                attrs: { small: "" },
                                                on: { click: _vm.previousPage }
                                              },
                                              on
                                            ),
                                            [
                                              _vm._v(
                                                " mdi-apple-keyboard-control "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  }
                                }
                              ])
                            },
                            [_c("span", [_vm._v("Anterior")])]
                          ),
                          _c(
                            "v-tooltip",
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u([
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    return [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            icon: "",
                                            disabled:
                                              _vm.currentPage >=
                                                _vm.accessPermissionsTotalPages ||
                                              _vm.accessPermissionElementsPerPageDisplayed ===
                                                0
                                          }
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            _vm._g(
                                              {
                                                staticClass: "right-arrow",
                                                attrs: { small: "" },
                                                on: { click: _vm.nextPage }
                                              },
                                              on
                                            ),
                                            [
                                              _vm._v(
                                                " mdi-apple-keyboard-control "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  }
                                }
                              ])
                            },
                            [_c("span", [_vm._v("Siguiente")])]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("v-divider"),
                  _c("v-progress-linear", {
                    attrs: {
                      active: _vm.loading,
                      color: "primaryGreen",
                      indeterminate: "",
                      rounded: "",
                      height: "2"
                    }
                  }),
                  _vm.accessPermissions && _vm.accessPermissions.length
                    ? _c(
                        "v-row",
                        {
                          staticClass: "mx-auto",
                          attrs: { justify: "center" }
                        },
                        [
                          _c(
                            "v-col",
                            { staticClass: "pa-0", attrs: { cols: "12" } },
                            [
                              _c(
                                "virtual-list",
                                {
                                  staticClass: "no-scroll",
                                  attrs: { size: 320, remain: 2 }
                                },
                                [
                                  _c(
                                    "v-list",
                                    {
                                      staticClass: "pa-0",
                                      attrs: {
                                        dense: "",
                                        "two-line": "",
                                        color: "transparent"
                                      }
                                    },
                                    [
                                      _vm._l(_vm.accessPermissions, function(
                                        accessPermission,
                                        i
                                      ) {
                                        return [
                                          _c(
                                            "v-list-item",
                                            {
                                              key: accessPermission.ticketId,
                                              class: {
                                                "access-permission-list-item elevation-1 d-flex pa-0": true,
                                                "blue-grey lighten-5": false
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.showTicketDetail(
                                                    accessPermission
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "v-list-item-content",
                                                {
                                                  staticClass:
                                                    "justify-space-between"
                                                },
                                                [
                                                  _c(
                                                    "v-container",
                                                    {
                                                      staticClass: "py-0",
                                                      staticStyle: {
                                                        "max-width": "none"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-row",
                                                        { staticClass: "py-0" },
                                                        [
                                                          _c(
                                                            "v-col",
                                                            {
                                                              staticClass:
                                                                "py-0 d-flex align-center",
                                                              attrs: {
                                                                cols: "7"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "v-list-item-title",
                                                                {
                                                                  class: {
                                                                    "font-weight-bold": false,
                                                                    "subtitle-2": true
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm.IS_EMPLOYEE
                                                                          ? "#" +
                                                                              accessPermission.id +
                                                                              " - "
                                                                          : ""
                                                                      ) +
                                                                      " " +
                                                                      _vm._s(
                                                                        _vm.getCustomerName(
                                                                          accessPermission.customer
                                                                        )
                                                                      ) +
                                                                      " " +
                                                                      _vm._s(
                                                                        _vm.getApplicantContact(
                                                                          accessPermission.accessContacts
                                                                        )
                                                                      ) +
                                                                      " "
                                                                  )
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "v-col",
                                                            {
                                                              staticClass:
                                                                "py-0 d-flex justify-end align-center overline",
                                                              attrs: {
                                                                cols: "5"
                                                              }
                                                            },
                                                            [
                                                              accessPermission.emergency
                                                                ? _c(
                                                                    "v-chip",
                                                                    {
                                                                      staticClass:
                                                                        "mx-1",
                                                                      attrs: {
                                                                        color:
                                                                          "red",
                                                                        label:
                                                                          "",
                                                                        "x-small":
                                                                          "",
                                                                        outlined:
                                                                          ""
                                                                      }
                                                                    },
                                                                    [
                                                                      _c("b", [
                                                                        _vm._v(
                                                                          "EMERGENCIA"
                                                                        )
                                                                      ])
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                              _c(
                                                                "v-chip",
                                                                {
                                                                  staticClass:
                                                                    "mx-1",
                                                                  attrs: {
                                                                    color:
                                                                      _vm
                                                                        .dataCenterColors[
                                                                        accessPermission
                                                                          .dataCenter
                                                                          .id -
                                                                          1
                                                                      ],
                                                                    label: "",
                                                                    "x-small":
                                                                      "",
                                                                    outlined: ""
                                                                  }
                                                                },
                                                                [
                                                                  _c("b", [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          _vm
                                                                            .dataCenterNames[
                                                                            accessPermission
                                                                              .dataCenter
                                                                              .id -
                                                                              1
                                                                          ]
                                                                        ) +
                                                                        " "
                                                                    )
                                                                  ])
                                                                ]
                                                              ),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "overline pl-1"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm.setFormatDate(
                                                                          accessPermission.date
                                                                        )
                                                                      ) +
                                                                      " "
                                                                  )
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "v-row",
                                                        { staticClass: "py-0" },
                                                        [
                                                          _c(
                                                            "v-col",
                                                            {
                                                              staticClass:
                                                                "font-weight-light body-2",
                                                              attrs: {
                                                                cols: "12 py-0"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.getAccessMotives(
                                                                      accessPermission.accessPermissionMotives
                                                                    )
                                                                  ) +
                                                                  " "
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "v-row",
                                                        {
                                                          staticClass:
                                                            "mx-auto pa-0"
                                                        },
                                                        [
                                                          _c(
                                                            "v-col",
                                                            {
                                                              staticClass:
                                                                "font-weight-light body-2 pa-0",
                                                              attrs: {
                                                                cols: "12"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "v-icon",
                                                                {
                                                                  attrs: {
                                                                    small: ""
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " mdi-ticket-confirmation-outline "
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(
                                                                " #" +
                                                                  _vm._s(
                                                                    accessPermission.ticketId
                                                                  ) +
                                                                  " "
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "v-row",
                                                        {
                                                          staticClass:
                                                            "mx-auto pa-0"
                                                        },
                                                        [
                                                          _c(
                                                            "v-col",
                                                            {
                                                              staticClass:
                                                                "font-weight-light body-2 pa-0",
                                                              attrs: {
                                                                cols: "12"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "v-row",
                                                                {
                                                                  staticClass:
                                                                    "mx-auto"
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-col",
                                                                    {
                                                                      staticClass:
                                                                        "pa-0",
                                                                      attrs: {
                                                                        cols:
                                                                          "12"
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-icon",
                                                                        {
                                                                          attrs: {
                                                                            small:
                                                                              ""
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " mdi-calendar "
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            _vm.setFormatDateWithHours(
                                                                              accessPermission.startDate
                                                                            )
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                      _c("b", [
                                                                        _vm._v(
                                                                          "-"
                                                                        )
                                                                      ]),
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            _vm.setFormatDateWithHours(
                                                                              accessPermission.endDate
                                                                            )
                                                                          ) +
                                                                          " "
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _c("v-divider", { key: i })
                                        ]
                                      })
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _c(
                        "v-row",
                        {
                          staticClass: "px-0",
                          attrs: { "fill-height": "", fluid: "" }
                        },
                        [
                          _c(
                            "v-row",
                            { attrs: { align: "center", justify: "center" } },
                            [
                              _c(
                                "v-col",
                                {
                                  staticStyle: { "text-align": "center" },
                                  attrs: { cols: "2", sm: "4" }
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: require("@/assets/empty-state-permits.png"),
                                      alt:
                                        "Actualmente no hay permisos de acceso para mostrar"
                                    }
                                  }),
                                  _c("p", [
                                    _vm._v(
                                      "Actualmente no hay permisos de acceso para mostrar"
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-snackbar",
            {
              attrs: { top: "", color: "error" },
              model: {
                value: _vm.errorLoadingContent,
                callback: function($$v) {
                  _vm.errorLoadingContent = $$v
                },
                expression: "errorLoadingContent"
              }
            },
            [
              _vm._v(
                " Ocurrió un error obteniendo los Permisos de Acceso al Data Center, por favor intente nuevamente "
              ),
              _c(
                "v-btn",
                {
                  attrs: { color: "white", text: "" },
                  on: {
                    click: function($event) {
                      !_vm.errorLoadingContent
                    }
                  }
                },
                [_vm._v("Cerrar")]
              )
            ],
            1
          ),
          _c(
            "v-snackbar",
            {
              attrs: { top: "", color: "success" },
              model: {
                value: _vm.successSendingAccessPermissionReview,
                callback: function($$v) {
                  _vm.successSendingAccessPermissionReview = $$v
                },
                expression: "successSendingAccessPermissionReview"
              }
            },
            [
              _vm._v(
                " El Permiso de Acceso " +
                  _vm._s(_vm.accessPermissionId) +
                  " fue revisado con éxito "
              ),
              _c(
                "v-btn",
                {
                  attrs: { color: "white", text: "" },
                  on: {
                    click: function($event) {
                      _vm.snackbar = false
                    }
                  }
                },
                [_vm._v("Cerrar")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }